import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable()
export class IntentAnalysisService {
  constructor(
    private api: ApiService,
  ) { }

  /////////////////////////////
  // PROVIDER
  getAllProvider(dealerId): Observable<any> {
    return this.api.get(`/dealers/${dealerId}/intent_analysis/providers`)
  }

  /////////////////////////////
  // SITE LEVEL
  getSiteConfig(dealerId, siteId): Observable<any> {
    return this.api.get(`/dealers/${dealerId}/sites/${siteId}/intent_analysis/config`)
  }

  updateSiteConfig(dealerId, siteId, data): Observable<any> {
    return this.api.put(`/dealers/${dealerId}/sites/${siteId}/intent_analysis/config`, data)
  }
}
